import { defineComponent as _defineComponent } from 'vue'
import { getLayoutData } from '@/apis/baseMaterial'
import { buryPoint } from '@/apis/common/buryPoint'
import { httpRequest } from '@/apis/request'
import { cancelFromBatchList, putIntoBatchList } from '@/apis/taskList'
import router from '@/router'
import store from '@/store'
import { translate } from '@/util/commonFun'
import { buryPointApi } from '@/util/commonFuncs'
import { dealPreLayoutDataLabelID } from '@/util/dealPaibanData'
import { showCardDetail } from '@/util/showCardDetail'
import Vue, { onMounted, onUnmounted, watch } from 'vue'
import { reactive, ref } from 'vue'

import { TaskType } from '../types/taskCard'

type PropsType = {
  task: TaskType
  clickAble?: boolean
  index?: number
}
// 给props绑定默认值
interface VOType {
  orderNo: string
  deliveryTime: string
  matCode: string
  texture: string
  texDir: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'm-task-card',
  props: {
    task: null,
    clickAble: { type: Boolean, default: true },
    index: null
  },
  emits: [
  'onAddToBatchList',
  'onRefuseTask',
  'onCancelBatch',
  'onDeleteTask',
  'onSaveToHistory',
  'onWarning',
],
  setup(__props: any, { expose, emit: emits }) {

const props = __props as { task: TaskType, clickAble: boolean, index?: number }



const taskCardRef = ref<HTMLElement>()
const isShowConfirmRefuse = ref<boolean>(false)
const refuseReson = ref<string>('')
const isLoading = ref<boolean>(false)
const maskType = ref<'refuse' | 'delete'>('refuse')

const orderKeysLabelMap = reactive<{ [key: string]: string }>({
  orderNo: 'common.orderNo',
  deliveryTime: 'taskPage.taskCard.delivery',
  texDir: 'common.texture',
  texture: 'common.color',
  matCode: 'common.matCode',
})

// 需要展示数据类型
const orderKeys = ref<Array<keyof VOType>>([
  'orderNo',
  'deliveryTime',
  'matCode',
  'texture',
  'texDir',
])
/** 添加任务至批量 */
async function handleAddtoBatchList() {
  isLoading.value = true
  const res = await putIntoBatchList({
    task_ids: [props.task.id],
    platform: 2,
  })
  isLoading.value = false
  if (res.status == 1) {
    transformAction()

    setTimeout(() => {
      emits('onAddToBatchList', props.task)
    }, 300)
    store.commit('setBatchPaiban', null)
    store.commit('setBatchNo', '')
    Vue.prototype.$message.success(translateLang('common.addSuccess'))
  } else {
    Vue.prototype.$message.error(translateLang('taskPage.taskCard.addErr'))
  }
}

function translateLang(key: string) {
  return translate(key)
}

/** 将任务从批量中取消 */
async function handleCancelBatch() {
  isLoading.value = true
  const res = await cancelFromBatchList({
    task_ids: [props.task.id],
    platform: props.task.platform,
  })
  isLoading.value = false
  if (res.status == 1) {
    transformAction('left')

    setTimeout(() => {
      emits('onCancelBatch', props.task)
    }, 300)
    Vue.prototype.$message.success(translateLang('taskPage.operationSuccess'))
    buryPointApi('task', 'cancel_task')
  } else {
    Vue.prototype.$message.error(translateLang('taskPage.operationFail'))
  }
}

/** 卡片的过渡效果 */
function transformAction(dir?: string) {
  if (taskCardRef.value) {
    if (dir) {
      taskCardRef.value.style.transformOrigin = 'left'
    }
    taskCardRef.value.style.transform = 'scale(0.1)'
  }
}

function handleClickRefuse() {
  isShowConfirmRefuse.value = true
  maskType.value = 'refuse'
  buryPointApi('task', 'refuse_task')
}

/** 取消拒绝 */
function handleCancelRefuse() {
  refuseReson.value = ''
  isShowConfirmRefuse.value = false
}

/** 确认拒绝 */
function handleConfirmRefuse() {
  if (maskType.value == 'refuse') {
    emits('onRefuseTask', props.task, refuseReson.value)
  } else {
    emits('onDeleteTask', props.task)
  }
  handleCancelRefuse()
}

/** 前往开料清单 */
async function handCardToMaterial() {
  if (!props.clickAble) return
  buryPoint({ function_module: 'task', function_point: 'click_task' })
  const plankJson = props.task.plank_json
  const paibanJson = props.task.paiban_json
  store.commit('setIsBatch', false)
  store.commit('setFilterMaterialList', null)
  store.commit('setBeforeSearchMaterialList', null)
  store.commit('setBeforeSizeFilterList', null)
  store.commit('setPaibanData', [])
  store.commit('setFilterObject', {})
  store.commit('setMaterialTask', [props.task])
  store.commit('setHasSendToTask', true)
  store.commit('setHasPrintTag', false)
  store.commit('changeHistoryStatus', false)
  store.commit('setIsShowSample', false)
  if (paibanJson) {
    store.commit('setPaibanTaskObj', null)
    router.push({
      path: '/materialList',
      query: {
        isTask: '1',
        paibanJson,
      },
    })
    // 设置是否展示loading
    store.commit('setIsNewPaiban', true)
  } else {
    const orderId = props.task.orderId
    isLoading.value = true
    let layoutData: any
    if (plankJson) {
      const { url } = JSON.parse(plankJson)
      if (url) {
        const res = await httpRequest.get(url)
        layoutData = res.layoutData
      }
    } else if (orderId) {
      const res = await getLayoutData({ room_ids: props.task.roomIds ?? [] })
      if (res.status == 1) {
        layoutData = res.data.result_data.map((data: any) => data).flat(1)
      }
    }
    isLoading.value = false
    if (layoutData && layoutData.length) {
      store.commit('setPreLayoutData', dealPreLayoutDataLabelID(layoutData))
      store.commit('setPaibanTaskObj', null)
      router.push('/materialList')
      store.commit('setIsNewPaiban', true)
    } else {
      emits('onWarning', true)
    }
  }
}

/** 点击删除按钮 */
async function handleClickDelete() {
  isShowConfirmRefuse.value = true
  maskType.value = 'delete'
  buryPointApi('task', 'del_task')
}

/** 点击存档按钮 */
async function handleSaveToHistory() {
  if (props.task.paiban_json) {
    emits('onSaveToHistory', props.task)
  }
  buryPointApi('task', 'save_to_history')
}

const mouseDownFn = (e: any) => {
  if (
    e.target &&
    e.target.className &&
    typeof e.target.className == 'string' &&
    !(
      e.target.className.includes('refuse-btn-confirm') ||
      e.target.className.includes('refuse-reson-input')
    )
  ) {
    isShowConfirmRefuse.value = false
  }
}

/** 取消卡片遮罩 */
window.addEventListener('mousedown', mouseDownFn)

const taskDetail: VOType = reactive({
  matCode: '',
  texture: '',
  texDir: '',
  orderNo: '',
  deliveryTime: '',
})
const plankJsonDetail = ref({})

onMounted(() => {
  if (
    props.task.plank_json &&
    JSON.parse(props.task.plank_json as any).matCode
  ) {
    plankJsonDetail.value = JSON.parse(props.task?.plank_json as any)
  }
})

// unMounted
onUnmounted(() => {
  // 取消事件监听
  window.removeEventListener('mousedown', mouseDownFn)
})
watch(
  () => props.task,
  async (newValue) => {
    if (
      newValue.plank_json &&
      !JSON.parse(newValue.plank_json as any).matCode
    ) {
      isLoading.value = true
      const res = await httpRequest.get(
        JSON.parse(newValue.plank_json as any).url
      )
      isLoading.value = false
      if (res.layoutData) {
        let taskDetailCopy = showCardDetail(res.layoutData)
        taskDetail.matCode = taskDetailCopy.matCode
        taskDetail.texture = taskDetailCopy.texture
        taskDetail.texDir = taskDetailCopy.texDir
      }
    }
  },
  {
    deep: true,
    immediate: true,
  }
)
expose({ transformAction })

return { __sfc: true,props, emits, taskCardRef, isShowConfirmRefuse, refuseReson, isLoading, maskType, orderKeysLabelMap, orderKeys, handleAddtoBatchList, translateLang, handleCancelBatch, transformAction, handleClickRefuse, handleCancelRefuse, handleConfirmRefuse, handCardToMaterial, handleClickDelete, handleSaveToHistory, mouseDownFn, taskDetail, plankJsonDetail }
}

})